<script setup>
import {onBeforeMount, ref, watch} from "vue";
import router from "@/router/index.js";
// 刷新时自动激活
import {getRoute} from "@/hooks/getRoute.js";
import {menuStore} from "@/store/store.js";
import {menuListHooks} from "@/hooks/menu.js";
import {handleGetMenuFirst} from "@/hooks/user.js";
const {route} = getRoute();

// 菜单配置
const list = ref([])

// 当前打开的菜单
const open = ref([])

// 加载状态
const loading = ref(false)
// 父组件传值
const props = defineProps({
  // 面包屑导航信息
  bread: {
    type: Array,
    default: () => []
  }
})

watch(
    () => props.bread,
    (newVal, oldVal) => {
      if (newVal !== oldVal) fatherActive()
    }
)

// 通过路由激活父项打开
const fatherActive = async () => {
  // item对应一级菜单，child对应二级菜单，grandson对应三级菜单
  open.value = []
  list.value.forEach(item => {
    if (item.childrenList.length > 0) {
      item.childrenList.forEach(child => {
        if (child.childrenList.length > 0) {
          if (route.meta.open[0] === item.menuCode && route.meta.open[1] === child.menuPermissions.menuCode) {
            open.value.push(`father${item.menuName}`)
            open.value.push(`son${child.menuPermissions.menuName}`)
            open.value.push(`collapsedSon${child.menuPermissions.menuName}`)
          }
        } else {
          if (route.meta.open[0] === item.menuCode) {
            open.value.push(`father${item.menuName}`)
          }
        }
      })
    }
  })
}
onBeforeMount(async () => {
  loading.value = true
  await menuListHooks()
  // 获取菜单信息
  await getMenu()
  // 激活父项
  await fatherActive()
  // 设置logo跳转链接
  logoLink.value = await handleGetMenuFirst()
  loading.value = false
})

// 链接跳转
function jumpTo(items) {
  const link = items.link || items.menuPermissions?.link
  if (link) router.push(link)
}

const collapsed = ref(false)
const handleCollapsed = () => {
  collapsed.value = !collapsed.value
  // 缩放时检测菜单栏打开状态
  if (collapsed) fatherActive()
}

// 获取当前用户菜单列表
async function getMenu() {
  list.value = menuStore().menu.menuList
}

// logo跳转链接
const logoLink = ref("/listMember")
</script>

<template>
  <div :class="collapsed ? 'menu_box_collapsed' : 'menu_box'" style="position: relative">
    <div style="position: absolute;top: 96px;right: 0;transform: translate(50%, -50%);z-index: 100;">
      <v-btn density="compact" size="large" color="#3c3c3c" :icon="collapsed ? 'mdi-menu-close' : 'mdi-menu-open'" @click="handleCollapsed"></v-btn>
    </div>

    <div v-if="!collapsed" style="position: absolute;top: 0;left: 0;width: 100%">
      <div class="flex_left" style="box-sizing: border-box;padding: 20px 30px 0 30px">
        <el-link type="default" :href="logoLink" :underline="false">
          <img class="logo mg_r_1" src="@/assets/images/logo.png" alt="">
          <div class="txt_nowrap"><h3 style="color: #fff">Biking Up</h3></div>
        </el-link>
      </div>
      <v-divider style="margin: 20px 10px;"></v-divider>
    </div>
    <div v-else style="position: absolute;top: 0;left: 0;width: 100%">
      <div class="flex_center" style="box-sizing: border-box;padding-top: 20px">
        <el-link type="default" :href="logoLink" :underline="false">
          <img class="logo" src="@/assets/images/logo.png" alt="">
        </el-link>
      </div>
      <v-divider style="margin: 20px 10px;"></v-divider>
    </div>

    <div style="height: 100%;box-sizing: border-box;padding-top: 89px" v-if="list.length > 0" v-loading="loading">
      <v-list v-model:selected="open" style="overflow-x: hidden;height: 100%" v-if="!collapsed" density="comfortable" open-strategy="list" v-model:opened="open">
        <v-list-group v-for='(item, index) in list' :key='`menu${index}`' :value="`father${item.menuName}`" :collapse-icon="item.childrenList.length > 0 ? '$collapse' : ''" :expand-icon="item.childrenList.length > 0 ? '$expand' :''">
          <template v-slot:activator="{ props }">
            <v-list-item
                v-bind="props"
                :title="`${item.menuName}`"
                :active="item.menuCode === route.meta.open[0]"
                color="#ffffff"
                :prepend-icon="item.icon"
                rounded="xl"
                @click="jumpTo(item)"
            ></v-list-item>
          </template>
          <div v-for="(sonItem, sonIndex) in item.childrenList">
            <v-list-group v-if="sonItem.childrenList.length > 0" :key='`sunMenu${sonIndex}`' :value="`son${sonItem.menuPermissions.menuName}`" :collapse-icon="sonItem.childrenList.length > 0 ? '$collapse' : ''" :expand-icon="sonItem.childrenList.length > 0 ? '$expand' :''">
              <template v-slot:activator="{ props }">
                <v-list-item
                    v-bind="props"
                    :active="sonItem.menuPermissions.menuCode === route.meta.open[1]"
                    color="#ffffff"
                    @click="jumpTo(sonItem.menuPermissions)"
                    rounded="xl"
                >
                  <v-list-item-title style="font-size: 15px" v-text="`&emsp;&emsp;${sonItem.menuPermissions.menuName}`"></v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                  v-for="(grandsonItem, grandsonIndex) in sonItem.childrenList"
                  :active="grandsonItem.menuPermissions.menuCode === route.meta.open[2]"
                  :key="`grandson${grandsonItem.menuPermissions.menuName + grandsonIndex}`"
                  :value="`grandson${grandsonItem.menuPermissions.menuName}`"
                  color="#ffffff"
                  @click="jumpTo(grandsonItem.menuPermissions)"
                  rounded="xl">
                <v-list-item-title style="font-size: 14px" v-text="`${grandsonItem.menuPermissions.menuName}`"></v-list-item-title>
              </v-list-item>
            </v-list-group>
            <div v-else>
              <v-list-item
                  v-bind="props"
                  :active="sonItem.menuPermissions.menuCode === route.meta.open[1]"
                  :key='`sunMenu1${sonIndex}`'
                  :value="`son1${sonItem.menuPermissions.menuName}`"
                  color="#ffffff"
                  @click="jumpTo(sonItem.menuPermissions)"
                  rounded="xl"
              >
                <v-list-item-title style="font-size: 15px" v-text="`&emsp;&emsp;${sonItem.menuPermissions.menuName}`"></v-list-item-title>
              </v-list-item>
            </div>
          </div>
        </v-list-group>
      </v-list>
      <v-list style="overflow-x: hidden;height: 100%" v-else density="comfortable" open-strategy="list" v-model:opened="open">
        <v-menu :close-on-content-click="false" open-on-hover v-for='(item, index) in list' location="right">
          <template v-slot:activator="{ props }">
            <v-list-item
                v-bind="props"
                :active="open.some(res => res === ('father' + item.menuName))"
                :key='"menu" + index'
                :value="`father${item.menuName}`"
                collapse-icon=""
                expand-icon=""
                :prepend-icon="item.icon"
                rounded="xl"
            >
            </v-list-item>
          </template>
          <v-list class="mg_l_1" v-model:opened="open" style="min-width: 200px" density="comfortable" open-strategy="list" v-if="item.childrenList.length > 0">
            <div v-for="(sonItem, sonIndex) in item.childrenList" >
              <v-list-group v-if="sonItem.childrenList.length > 0" :value="`collapsedSon${sonItem.menuPermissions.menuName}`" :collapse-icon="sonItem.childrenList.length > 0 ? '$collapse' : ''" :expand-icon="sonItem.childrenList.length > 0 ? '$expand' :''">
                <template v-slot:activator="{ props }">
                  <v-list-item
                      v-bind="props"
                      :active="sonItem.menuPermissions.menuCode === route.meta.open[1]"
                      color="#ffffff"
                      :title="sonItem.menuPermissions.menuName"
                      @click="jumpTo(sonItem.menuPermissions)"
                      rounded="xl"
                  ></v-list-item>
                </template>
                <v-list-item
                    v-for="(grandsonItem, grandsonIndex) in sonItem.childrenList"
                    :active="grandsonItem.menuPermissions.menuCode === route.meta.open[2]"
                    :key="'collapsedGrandsonItem' + grandsonItem.menuPermissions.menuName + grandsonIndex"
                    :value="grandsonItem.menuPermissions.menuName"
                    color="#ffffff"
                    @click="jumpTo(grandsonItem.menuPermissions)"
                    rounded="xl">
                  <v-list-item-title style="font-size: 14px" v-text="grandsonItem.menuPermissions.menuName"></v-list-item-title>
                </v-list-item>
              </v-list-group>
              <div v-else>
                <v-list-item
                    v-bind="props"
                    :active="sonItem.menuPermissions.menuCode === route.meta.open[1]"
                    :key='`sunMenu1${sonIndex}`'
                    :value="`son1${sonItem.menuPermissions.menuName}`"
                    color="#ffffff"
                    @click="jumpTo(sonItem.menuPermissions)"
                    rounded="xl"
                >
                  <v-list-item-title style="font-size: 15px" v-text="`${sonItem.menuPermissions.menuName}`"></v-list-item-title>
                </v-list-item>
              </div>
            </div>
          </v-list>
          <div class="tips_box mg_l_1" v-else>
            {{item.menuName}}
          </div>
        </v-menu>
      </v-list>
    </div>
  </div>

</template>

<style lang="scss" scoped>
.v-list {
  background: #1a1a1a!important;
  color: #a1a1a1;
  border-radius: 5px;
  position: relative;
  overflow: auto;
  width: 100%;
}
/*v-list滚动条样式*/
.v-list::-webkit-scrollbar {
  width: 10px;
}
/*v-list滚动条滑块样式*/
.v-list::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
/*v-list滚动条滑块悬停样式*/
.v-list::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
/*v-list滚动条轨道样式*/
.v-list::-webkit-scrollbar-track {
  border-radius: 10px;
}
.v-list-item {
  justify-items: start;
}
.tips_box {
  min-width: 120px;
  height: 40px;
  background-color: rgba(66, 66, 66, .9);
  color: #fff;
  border-radius: inherit;
  line-height: 40px;
  box-sizing: border-box;
  padding: 0 15px;
}
.logo {
  width: 48px;
  height: 48px;
  border-radius: 48px;
}
</style>
